module.exports = __webpack_public_path__ + "static/img/pay.2419bdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buy/pay.png
// module id = hpb8
// module chunks = 1